import Swal from 'sweetalert2';
import type { SweetAlertIcon, SweetAlertOptions } from 'sweetalert2'

export const showMessage = (type: SweetAlertIcon ,title: string, message: string, props?: SweetAlertOptions)=> {
    Swal.fire({
    icon: type,
    title,
    text: message,
    ...props
});
}

